import { FC } from "react";

import { ProcedureProjectOwner } from "@/model/Procedure/ProcedureProjectOwner";

export interface IProcedureProjectOwnerListItemProps {
  Owner: ProcedureProjectOwner;
}
export const ProcedureProjectOwnerListItem: FC<
  IProcedureProjectOwnerListItemProps
> = (props) => {
  return <option value={+props.Owner.UserId}>{props.Owner.Name}</option>;
};
